<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.zencustomers" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				<a [routerLink]="['/' + ac.urls.zencustomers]">ZEN Master Sites</a>
			</li>
			<li class="breadcrumb-item"><a [routerLink]="['/' + ac.urls.zencustomers, 'reports']">Reports</a></li>
			<li class="breadcrumb-item active" aria-current="page">
				Users
			</li>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
			<!-- <button type="button" class="btn btn-outline-secondary me-2" (click)="toggleFilters()">
				<fa-icon icon="filter" size="sm"></fa-icon>
				<span class="cp-action-button-text">Filter</span>
			</button> -->

			<button type="button" class="btn btn-outline-secondary me-2" (click)="loadZenObjects(true)">
				<fa-icon icon="sync-alt" size="sm" [spin]="loading" ngbTooltip="Refresh" placement="start"></fa-icon>
				<!-- <span class="cp-action-button-text">Refresh</span> -->
			</button>

		</div>
	</div>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>
	<div *ngIf="loading" style="text-align: center;">
		<app-loading-spinner></app-loading-spinner>
	</div>

	<app-table-zen-users></app-table-zen-users>
</div>